
import React, { useState } from 'react';
import { Shield, Lock, User, X } from 'lucide-react';

interface AdminLoginProps {
  onLogin: () => void;
  onClose: () => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin, onClose }) => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Credenciais atualizadas conforme solicitação do usuário
    if (user === 'niikoelucite' && pass === '3436869#') {
      onLogin();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div className="fixed inset-0 z-[400] flex items-center justify-center p-6 animate-in fade-in duration-300">
      <div className="absolute inset-0 bg-black/95 backdrop-blur-3xl" onClick={onClose} />
      <div className="relative w-full max-w-md bg-zinc-900 border border-white/5 shadow-2xl p-12">
        <div className="text-center mb-12">
          <div className="inline-flex p-5 bg-white mb-6 border-b-4 border-[#c084fc] shadow-xl">
            <Shield className="w-10 h-10 text-black" />
          </div>
          <h2 className="text-2xl font-black text-white uppercase tracking-tighter">Acesso Restrito</h2>
          <p className="text-zinc-600 text-[10px] font-black uppercase tracking-[0.4em] mt-2">Câmara do Administrador</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-700" />
              <input 
                autoFocus
                type="text"
                placeholder="Usuário"
                className="w-full bg-black border border-zinc-800 py-5 pl-12 pr-6 text-white outline-none focus:border-[#c084fc] transition-all"
                value={user}
                onChange={e => setUser(e.target.value)}
              />
            </div>
          </div>
          <div className="space-y-2">
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-700" />
              <input 
                type="password"
                placeholder="Senha"
                className="w-full bg-black border border-zinc-800 py-5 pl-12 pr-6 text-white outline-none focus:border-[#c084fc] transition-all"
                value={pass}
                onChange={e => setPass(e.target.value)}
              />
            </div>
          </div>
          
          {error && <p className="text-red-500 text-[10px] font-black text-center uppercase tracking-widest animate-pulse">Credenciais inválidas</p>}

          <button type="submit" className="w-full bg-white hover:bg-[#c084fc] text-black hover:text-white font-black py-5 transition-all uppercase tracking-widest text-xs shadow-xl active:scale-95">
            Entrar no Sistema
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
